import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';
import denApi from '@/lib/api/denApi';
import type { Signature } from '@/types/signature';
import type { OrgOpSignableDecision } from '@mls-wallet/shared-types';

type CreateGroupSignatureArg = {
  proposalId: string;
  decision: OrgOpSignableDecision;
};

const fetcher = async (
  _key: string,
  { arg }: { arg: CreateGroupSignatureArg }
): Promise<Signature[]> => {
  const { proposalId, decision } = arg;
  return await denApi.post<Signature[], { decision: OrgOpSignableDecision }>(
    `admin/group/group-proposals/${encodeURIComponent(proposalId)}/signatures`,
    { decision }
  );
};

export function useGroupProposalSignature(
  swrOptions?: SWRMutationConfiguration<
    Signature[],
    Error,
    string,
    CreateGroupSignatureArg
  >
) {
  const { trigger, isMutating, error } = useSWRMutation<
    Signature[],
    Error,
    string,
    CreateGroupSignatureArg
  >('admin/group/group-proposals/signature', fetcher, swrOptions);

  return { createSignature: trigger, isLoading: isMutating, error };
}
